import { Box, Button, Flex, Text, Textarea } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import { repositoryPos } from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import { useState } from "react";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { modals } from "@mantine/modals";

const UpdateCollectionFormWeb = ({
  id,
  status,
  onClose,
}: {
  id: number;
  status: string;
  onClose: any;
}) => {
  const [description, setDescription] = useState<string>("");
  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  const dataUser = JSON.parse(localStorage.getItem("userLoginHeader") ?? "");

  const handleSubmit = async () => {
    if (description.length > 0) {
      let url = "";

      if (description.length > 0) {
        url += `&Description=${description}`;
      }

      const res = await repositoryPos.post<MessageResponse<any>>(
        `/api/v1/CollectionFormWeb/update?Id=${id}&Status=${status}&EmpId=${dataUser?.id}` +
          url
      );

      if (res && res.success) {
        NotificationExtension.Success("Cập nhật trạng thái thành công !");

        setTimeout(() => {
          modals.closeAll();
          onClose((prev: boolean) => !prev);
        }, 1000);
      }
    } else {
      setIsSubmit(true);
    }
  };

  return (
    <Box mx="auto" w={"50vw"} maw={750}>
      <Flex gap={"xs"} align={"center"} mt={10}>
        <Text fw={500}>Trạng thái: </Text>
        <Text fw={500}>
          {status === "TIEP_NHAN" ? "Tiếp nhận" : "Đã xử lý"}
        </Text>
      </Flex>
      <Flex gap={"xs"} align={"center"} mt={10}>
        <Text fw={500}>Người tiếp nhận: </Text>
        <Text fw={500}>
          {JSON.parse(localStorage.getItem("userLoginHeader") ?? "")?.code} -{" "}
          {JSON.parse(localStorage.getItem("userLoginHeader") ?? "")?.fullname}
        </Text>
      </Flex>
      <Textarea
        label="Ghi chú"
        placeholder="Nhập ghi chú"
        value={description}
        mt={10}
        onChange={(e) => setDescription(e.currentTarget.value)}
        error={
          description.length === 0 && isSubmit ? "Vui lòng nhập ghi chú !" : ""
        }
        withAsterisk
      />
      <Flex justify={"center"} align={"center"} gap={"md"} mt={10}>
        <Button
          color="teal"
          leftSection={<IconCheck size={14} />}
          onClick={() => handleSubmit()}
        >
          Xác nhận
        </Button>
      </Flex>
    </Box>
  );
};

export default UpdateCollectionFormWeb;
